import type { IGetDetailResult } from "../interfaces/get-detail.interface"
import axios from "./axios"


const getDetailItem = async (id: number): Promise<IGetDetailResult | undefined> => {

    const { data } = await axios.get('/nft-sales/'+id)
    
    if(data.code != 200) return undefined
  
    return data.data 
  }

export default getDetailItem